import {
  ChipField,
  EditButton,
  SimpleShowLayout,
  TextField,
  useRecordContext,
} from 'react-admin';

export const AppDocumentsCommandPanel = () => {
  const record = useRecordContext();

  return (
    <SimpleShowLayout record={record}>
      <ChipField source="id" />
      <TextField source="title" />
      <EditButton />
    </SimpleShowLayout>
  );
};
